module.exports = __webpack_public_path__ + "static/media/Fun88_Affiliate_Euro_2024_logo.deec27b9.png";